import type { AccessGroup } from '@/api/auth';

/**
 * The three groups, in the order §6.10 offers them: **widest first**.
 *
 * ⚠️ **Not alphabetical, and not the order `apps.accounts.groups` happens to list.** A reader
 * choosing a group is choosing how much somebody may do, so the list reads from most to least — an
 * order that carries the meaning rather than the spelling. `Admin`, `Recruiter`, `Interviewer` is also
 * the order §5's own table uses, and the order `CONTEXT.md`'s Group table uses, so the three documents
 * agree.
 *
 * ⚠️ **The names are the API's values, not labels.** `AccessGroup` comes from the generated schema, so
 * a group renamed on the server is a type error here rather than a `Select` that submits a name the
 * API refuses. They are deliberately **not** translated: they are the identifiers `StaffIn.group` and
 * `StaffOut.groups` carry, and a localised label would have to be mapped back to a value — a mapping
 * that is one more thing to keep in step for no gain while there is one catalogue (§11).
 */
export const GROUP_OPTIONS: readonly AccessGroup[] = ['Admin', 'Recruiter', 'Interviewer'];
